/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { useContext } from 'react';

import { SGAPageContext } from 'bundles/grading/components/staff-graded-assignments/SGAPageContext';
import { InlineFeedbackRubricContext } from 'bundles/grading/components/staff-graded-assignments/form-parts/InlineFeedbackRubricContext';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
import RubricShell from 'bundles/grading/components/staff-graded-assignments/form-parts/RubricShell';
import NoSubmission from 'bundles/grading/components/staff-graded-assignments/middle-panel/NoSubmission';
import QuestionShell from 'bundles/grading/components/staff-graded-assignments/middle-panel/QuestionShell';
import QuestionSummary from 'bundles/grading/components/staff-graded-assignments/middle-panel/QuestionSummary';
import SGALazyLoadMiddlePanel from 'bundles/grading/components/staff-graded-assignments/middle-panel/SGALazyLoadMiddlePanel';
import SubmissionHeading from 'bundles/grading/components/staff-graded-assignments/middle-panel/SubmissionHeading';
import { getRubricId } from 'bundles/grading/utils/formPartUtils';
import { isRubricBoxView } from 'bundles/grading/utils/submissionUtils';

const styles = {
  container: css`
    padding: 0 var(--cds-spacing-1000) var(--cds-spacing-600);

    /* this allows max-width=600px for Question's prompt and response */
    max-width: 896px;
    margin: 0 auto;
  `,
  questionContainer: css`
    margin: 0 0 var(--cds-spacing-300) 0;

    .rc-BoxViewDocumentAnnotation__prompt {
      display: none;
    }
  `,
};

const SGAMiddlePanel = () => {
  const { submissionData } = useContext(SGAPageContext);
  const { isReadOnly } = useContext(InlineFeedbackRubricContext);
  const { submission } = submissionData.data || {};

  if (submissionData.error) {
    return null;
  }

  if (submissionData.loading) {
    return <SGALazyLoadMiddlePanel />;
  }

  if (!submission || !submissionData.data?.submitter) {
    return submissionData.data?.submitter ? <NoSubmission /> : null; // can be an empty team sga with no submitters
  }

  const inlineFeedbackRubric =
    submission?.currentRubric && isRubricBoxView(submission?.currentRubric) ? submission.currentRubric : null;

  return (
    <div css={styles.container}>
      <SubmissionHeading submitter={submissionData.data.submitter} />

      {submission.currentQuestionId === 'all' && <QuestionSummary questions={submission.questions} />}

      {submission.currentQuestion && (
        <div css={styles.questionContainer}>
          <QuestionShell question={submission.currentQuestion} />
          {inlineFeedbackRubric && (
            <RubricShell
              key={getRubricId(inlineFeedbackRubric)}
              rubric={inlineFeedbackRubric}
              // explicitly setting a read-only state for inline-feedback-rubrics to ensure
              // we don't override other rubric type read-only states
              isReadOnly={isReadOnly}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default SGAMiddlePanel;
